import { createContext, useContext, useEffect, useState } from "react";
import PropTypes from "prop-types";
import { vehiclePerson_getList } from "src/components/vehicle/VehicleFunctions";
import { userContext } from "./userContext";

export const StatCacheContext = createContext();

export const StatCacheProvider = ({ children }) => {
  const { userAsiakas, token, isLoggedIn } = useContext(userContext) || {};
  const [vehicleDriverList, setVehicleDriverList] = useState(null);
  const ownerAsiakasId = userAsiakas?.asiakasId;

  useEffect(() => {
    if (!isLoggedIn) return;
    // clear cache when ownerAsiakasId changes
    // cache is saved when getting and fetching data
    if (vehicleDriverList !== null) {
      console.log("CLEARING CACHE", ownerAsiakasId);
      setVehicleDriverList(null);
    }
  }, [ownerAsiakasId, isLoggedIn]);

  const initVehicleDriverList = async (ownerAsiakasId) => {
    let _data = null;
    if (vehicleDriverList === null) {
      _data = await vehiclePerson_getList(ownerAsiakasId, token);
      setVehicleDriverList(_data);
      return _data;
    }
    return vehicleDriverList;
  };

  const getVehicleDriverList = async (ownerAsiakasId, vehicleId, months = null) => {
    if (!isLoggedIn) {
      console.log("getVehicleDriverList: not logged in");
      return null;
    }
    // 0 months means current month
    // null months means all months
    let _data = await initVehicleDriverList(ownerAsiakasId);
    let date = new Date();
    date.setMonth(date.getMonth() - months);
    if (_data) {
      _data = _data.filter((item) => item.vehicleId === vehicleId);
      if (months !== null) {
        let date = new Date();
        date.setMonth(date.getMonth() - months);
        let yyyymm = date.getFullYear() * 100 + date.getMonth() + 1;
        _data = _data.filter((item) => item.year * 100 + item.month >= yyyymm);
      }
    }
    // consolidate data, calculate totals of keikkaCount for each driver
    let driverList = [];
    if (_data) {
      _data.forEach((item) => {
        let driver = driverList.find((driver) => driver.personId === item.personId);
        if (driver) {
          driver.keikkaCount += item.keikkaCount;
          driver.keikkaMinutes += item.keikkaMinutes;
          driver.m3 += Math.round(item.m3 / 10) * 10;
        } else {
          driverList.push({
            personFirstName: item.personFirstName,
            personLastName: item.personLastName,
            personFullName: item.personFirstName + " " + item.personLastName,
            personId: item.personId,
            keikkaCount: item.keikkaCount,
            keikkaMinutes: item.keikkaMinutes,
            m3: Math.round(item.m3 / 10) * 10,
          });
        }
      });
    }
    // sort driverList by keikkaCount
    driverList.sort((a, b) => b.keikkaCount - a.keikkaCount);
    return driverList;
  };

  return (
    <StatCacheContext.Provider value={{ getVehicleDriverList }}>
      {children}
    </StatCacheContext.Provider>
  );
};

export const useStatCache = () => useContext(StatCacheContext);

StatCacheProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
